import {AfterViewInit, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {ButtonTypeEnum} from '@shared/button/button.directive';
import {LightBoxService} from '@shared/modules/content/services/lightbox/light-box.service';
import {LightBoxInterface} from '@shared/modules/content/interfaces/light-box.interface';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

@Component({
    selector: 'app-lightbox-dialog',
    templateUrl: './lightbox-dialog.component.html',
    styleUrls: ['./lightbox-dialog.component.scss'],
})
export class LightboxDialogComponent implements OnInit, AfterViewInit, OnDestroy {
    #subscriptions: Subscription[] = [];

    readonly buttonType = ButtonTypeEnum;

    contentElement!: HTMLImageElement;

    src: string;

    images: LightBoxInterface[] = [];

    slideIndex = 0;

    showImage: boolean = true;

    isMobile: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<LightboxDialogComponent>,
        private lightBoxService: LightBoxService,
        breakpointObserver: BreakpointObserver,
        @Inject(MAT_DIALOG_DATA) public data: {
            showImage: boolean;
            contentElement: HTMLImageElement},
    ) {
        this.contentElement = data.contentElement;
        this.showImage = data.showImage;
        this.src = data.contentElement.src;
        this.contentElement.alt = this.data.contentElement.alt || this.data.contentElement.title;
        this.isMobile = breakpointObserver.isMatched(Breakpoints.XSmall);
    }

    ngOnInit() {
        this.loadImages();
    }

    ngAfterViewInit() {
        const defaultIndex: number = this.images.map((image: LightBoxInterface) => image.label).indexOf(this.contentElement.alt);

        this.currentSlide(defaultIndex !== -1 ? defaultIndex + 1 : 1);
    }

    loadImages(): void {
        this.lightBoxService.fetchImages().subscribe(images => {
            const uniqueImages = images.filter((image, index, self) =>
                index === self.findIndex((img) => img.src === image.src),
            );

            const currentImageIndex = uniqueImages.findIndex(image => image.src === this.src);

            if (currentImageIndex !== -1) {
                const [currentImage] = uniqueImages.splice(currentImageIndex, 1);

                this.images = [currentImage, ...uniqueImages];
            } else {
                this.images = [{
                    label: this.contentElement.alt,
                    src: this.src,
                    showImage: this.showImage,
                    index: currentImageIndex,
                }, ...uniqueImages];
            }
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    plusSlides(n: number): void {
        this.showSlides(this.slideIndex += n);
    }

    currentSlide(n: number): void {
        this.showSlides(this.slideIndex = n);
    }

    showSlides(n: number) {
        let i;
        const slides = document.getElementsByClassName('lightbox__slides') as HTMLCollectionOf<HTMLElement>;
        const dots = document.getElementsByClassName('images') as HTMLCollectionOf<HTMLElement>;

        if (n > slides.length && this.data.showImage) {
            this.slideIndex = 1;
        }

        if (n < 1 && this.data.showImage) {
            this.slideIndex = slides.length;
        }

        for (i = 0; i < slides.length; i++) {
            slides[i].style.display = 'none';
        }

        for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(' active', '');
        }

        slides[this.slideIndex - 1].style.display = 'block';
        if (dots && dots.length > 0) {
            dots[this.slideIndex - 1].className += ' active';
        }
    }

    ngOnDestroy(): void {
        this.#subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
